import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { merge, Observable, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { Roles } from '../../model/roles';
import { SortableColumn } from '../../model/sort/sortable-column';
import { StoreMaintainenceResponse } from '../../model/store-maintainence-response';
import { UserData } from '../../model/user-data';
import { UsersDataResponse } from '../../model/users-data-response';

@Component({
    selector: 'app-store-users',
    templateUrl: './store-users.component.html',
    styleUrls: ['./store-users.component.scss'],
    standalone: false
})
export class StoreUsersComponent implements OnInit {
  displayedColumns: string[] = ['userid', 'firstname', 'lastname', 'license', 'userrole', 'status', 'action'];
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  filter:string='';
  dataSource: MatTableDataSource<UsersDataResponse>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  user: UsersDataResponse;
  userData: UserData;
  storeUserForm: UntypedFormGroup;
  sortableColumn: SortableColumn;
  stores:StoreMaintainenceResponse[];
  addUserButton:boolean=false;
  //filteredOptions: Observable<string[]>;
  filteredStoreOptions: Observable<StoreMaintainenceResponse[]>;
  selectedStoreNumber='';
  //options: string[] = [];
  constructor(private router: Router,private route:ActivatedRoute, private userservice: UserService, private fb: UntypedFormBuilder) {

    this.createForm();

    this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
     this.stores =this.user.stores.filter(s=>(s.roleId===4));
     //this.options = this.user.stores?this.user.stores.map(value => (value.banner +"-"+ value.sdmStoreNumber)):null;
     //this.options = this.user.stores?this.user.stores.map(value => (value.storeNumber)):null;
     this.onchangeStore();

      this.userData = data.userData;
      if(this.stores ===null ||this.stores.length===0){
        this.addUserButton=true;
      }
    })

    
        
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<UsersDataResponse>();
    this.route.params.subscribe(
      (params) => 
      { 
       if(params.storeNumber){ 
      this.storeUserForm.patchValue({
      storeNumber:params.storeNumber
       })         
       }}
    )

    // this.filteredOptions = this.storeUserForm.controls.storeNumber.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filter(value))
    //   );

      this.filteredStoreOptions = this.storeUserForm.controls.storeNumber.valueChanges
      .pipe(
        startWith(''),
        map(value => this.store_filter(value))
      );

      //  this.filteredStoreOptions = this.storeUserForm.controls.storeNumber.valueChanges
      // .pipe(
      //   startWith({} as StoreMaintainenceResponse),
      //   map(user => user && typeof user === 'object' ? user.storeNumber : user),
      //   map(name => name ? this.filterStores(name) : this.options.slice())
      //  // map(value => this._filter(value))
      // );  
  }

  // filterStores(name: string): StoreMaintainenceResponse[] {
  //   return this.stores.filter(option =>
  //     option.storeNumber.toLowerCase().indexOf(name.toLowerCase()) === 0);
  // }

  ngAfterViewInit() {
    this.getUsersData();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    //  this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);


  }
  createForm() {
    this.storeUserForm = this.fb.group({
      storeNumber: ['', Validators.required],
      status: ['Y'],


    });

  }

  sortData(sort: Sort) {
    this.sortableColumn = new SortableColumn('', '', '');
    const sortedData: boolean | Array<any> = this.sortableColumn.sortTableData(sort, this.dataSource.data, this.displayedColumns);
    if (sortedData) {
      this.dataSource.data = sortedData as Array<any>;
    }
  }

getRoledID(roles:Roles[]){
  let roleId=[]
  roles.forEach(element => {
  roleId.push(element.roleIdAccess)
});
return roleId.toString();
}


  getUsersData() {
    if(this.storeUserForm.value.storeNumber){
    this.dataSource = new MatTableDataSource<UsersDataResponse>();
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          return this.userservice!.getAllUsersByStore(this.storeUserForm.value.status,
            0, this.storeUserForm.value.storeNumber, this.getRoledID(this.user.lstAccess),
            this.sort.active, this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalElements;

          return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.dataSource = new MatTableDataSource<UsersDataResponse>(data));
      }
  }

  addUser() {
    this.router.navigate(['/dcn-esign/store-management/add-edit-store-user'],{ queryParams:{'action': 'store-user-add' } });
  }

  editUser(user: UserData) {
    this.router.navigate(['/dcn-esign/store-management/add-edit-store-user', user.sequenceNumber], { queryParams: {'store-number':this.storeUserForm.value.storeNumber, 'action': 'store-user-edit' } });
  }

  applyFilter(filterValue: string) {
    
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.filter=filterValue;
    this.dataSource.filter = filterValue;
  }

  onchangeStore() {
  }

  private store_filter(value: string): StoreMaintainenceResponse[] {
  
    const filterValue =  value !== null ? value.toLowerCase() : '';
     
    let upn:any=[];
    if(filterValue!==''){
      let fvalue=Number(filterValue);    
      if(!isNaN(fvalue)){       
        let options= this.stores.filter(option => parseInt(option.sdmStoreNumber).toString().toLowerCase().includes(filterValue));
        options.sort((a,b) =>  (a > b ? 1 : -1));
    return options;
      }

    upn=this.stores.filter(option => (option.banner+"-"+option.sdmStoreNumber).toLowerCase().includes(filterValue));
    }else{
      upn=this.stores.filter(option => option);
    }
    upn.sort((a, b) => a.storeNumber.toLowerCase().localeCompare(b.storeNumber.toLowerCase()))
    return upn;
  }

  private _filter(value: string): string[] {

    const filterValue = value !== null ? value.toLowerCase() : '';
    let upn:any=[];
    if(filterValue!==''){
    //upn=this.options.filter(option => option.toLowerCase().startsWith(filterValue));
    }else{
     // upn=this.options.filter(option => option);
    }
   upn.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    return upn;
   
  }

  displayFn(storeNumber: string): string {
    if(this.stores!=null){
    let s= this.stores.find(option => (option.storeNumber).toLowerCase()===storeNumber);
    return s ? (s.banner+"-"+s.sdmStoreNumber) : '';
    }
  }
  
  getSelectedStore(store: string)
  {
    //console.log(store);
  }

}
